import React from 'react';
import logo from '../../Assets/logo.png';
import "./navbar.css";
import { Link } from 'react-router-dom';



function Navbar() {
  
  return (
    <div>
      <nav className='nav1'>
        <ul>
          
          {/* {/* <div className="sidebar"><i className="bi bi-list"></i>
            <span className="dot"></span>
          </div> */}
          <div className="img">
            <img src={logo} alt="logo" />
          </div>
          <Link to="/">Home</Link>
          <div className="elem">
           
            <p>Internsala<i className="bi bi-caret-down-fill"></i>
              <div className="dropdown-content">
                <a href="">Internships</a>
                <a href="#">Projects</a>
              </div>
            </p>
            <p>Jobs<i className="bi bi-caret-down-fill"></i>
              <div className="dropdown-content">
                <a href="#">Full-time</a>
                <a href="#">Part-time</a>
              </div>
            </p>
          </div>

          <div className="search">
            <i className="bi bi-search"></i>
            <input type="text" placeholder='search' />
          </div>
          <div className="auth">
            <Link to="/Login"className='btn1'>Login</Link>
            <Link to="/Registration"className='btn2'>Register</Link>
          </div>
          <div className="Admin">
            Admin
          </div>
          <div className="flex mt-7">
            Hire Talent
          </div>
        </ul>
      </nav>
    </div>
  )
}

export default Navbar;
